import type { BatchFormResults, BulkCloneFormRequest, CloneFormRequest } from 'apiConnector/batch-workspace';
import { batchWorkspaceApiConnector } from 'apiConnector/batch-workspace';
import { tabRemoved } from 'epic/workspace/common/tabs/tabsEpics';
import type { Action } from 'redux';
import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';
import { catchError, mergeMap, takeUntil } from 'rxjs/operators';
import { defaultBatchFormFailed } from 'state/batchForm/batchForm.action';
import { batchFormsReceivedThunk } from 'state/batchForm/batchForm.thunks';
import type { EpicWithThunk } from 'state/state.common';

export interface BatchFormsBulkCloneApi {
  bulkCloneForms(request: BulkCloneFormRequest): Observable<BatchFormResults>;
}

export function cloneFormsEpic(): EpicWithThunk {
  return (actions$, state$, { httpClient }) => {
    return actions$.pipe(
      ofType('BATCH_FORMS_CLONE_REQUESTED'),
      mergeMap(({ tabId, formsToBeCloned, temporaryFormIds, productSubType, productType }) => {
        const tabRemoved$ = tabRemoved(actions$, tabId, state$);
        const requestForCloneForm: BulkCloneFormRequest = {
          productType: productType,
          productSubType: productSubType,
          forms: Object.keys(formsToBeCloned).map<CloneFormRequest>(formId => ({
            negotiationId: formId,
          })),
        };

        return batchWorkspaceApiConnector(httpClient)
          .bulkCloneForms(requestForCloneForm)
          .pipe(
            takeUntil(tabRemoved$),
            mergeMap(cloneFormResponse =>
              of(batchFormsReceivedThunk(tabId, temporaryFormIds, cloneFormResponse.forms)),
            ),
            catchError((_: Error) => {
              const duplicateFailedActions: Action[] = temporaryFormIds.map(id => defaultBatchFormFailed(id));
              return of(...duplicateFailedActions);
            }),
          );
      }),
    );
  };
}
